(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceController', NasracSourceController);
    window.localStorage.removeItem("DataTables_nasracsourcebar_/");
    NasracSourceController.$inject = ['$scope', '$state', 'NasracSource', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider', 'Principal'];

    function NasracSourceController ($scope, $state, NasracSource, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal ) {
        var vm = this;
        vm.nasracSources = [];

        vm.nasracSources = {
        		createRoles: "Administrators,DAC Content Administrator"
        	};

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/nasrac-sources/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },
            data: function(data, dtInstance) {

                // The returned object has 'email' as property, but the server entity has 'emailAddress'
                // We need to override what we ask to the server here otherwise search will not work
//                data.columns[1].data = "emailAddress";
            	data.columns.shift();
            	data.order[0].column = data.order[0].column - 1;
            	data.columns[2].data = 'nasracSourceType.sourceType';

                // Any values you set on the data object will be passed along as parameters to the server
                //data.access_token = AuthenticationService.getAccessToken();
            	//alert(JSON.stringify(data));
                return JSON.stringify(data);
            }
        })
            .withOption('stateSave',true)
            .withDOM(
			"<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
			"<'row'<'col-sm-12'tr>>" +
			"<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
        .withBootstrapOptions({
            TableTools: {
                classes: {
                    container: 'btn-group',
                    buttons: {
                        normal: 'btn btn-danger'
                    }
                }
            },
            ColVis: {
                classes: {
                    masterButton: 'btn btn-primary'
                }
            },
            pagination: {
                classes: {
                    ul: 'pagination pagination-sm'
                }
            }
        })
    .withPaginationType('full_numbers')
    .withButtons([
	    {
	    	text: 'Export',
	    	extend: "excelHtml5",
	        title:"Nasrac Sources",
	        action: function (e, dt, node, config) {
	        	NasracSource.download().$promise
	            .then(function (data) {
	            	var url = URL.createObjectURL(data.response);
	            	var link = document.createElement("a");
	        	    link.href = url;

	        	    //set the visibility hidden so it will not effect on your web-layout
	        	    link.style = "visibility:hidden";
	        	    link.download = "NAS-RAC_Sources.xlsx"; //this is an example file to download, use yours

	        	    //this part will append the anchor tag and remove it after automatic click
	        	    document.body.appendChild(link);
	        	    link.click();
	        	    document.body.removeChild(link);
	              });
	        },
	        exportOptions: {
	            columns: ':visible'
	        },
	        //CharSet: "utf8",
	        exportData: { decodeEntities: true }
	    }
	])

    .withDisplayLength(25)

    .withOption('createdRow', function (row) {
        // Recompiling so we can bind Angular directive to the DT
        $compile(angular.element(row).contents())($scope);
    })
    .withOption('saveState', true)
    .withOption('order', [1, 'asc'])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
	            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '80px').notSortable()
	            .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('id').withTitle('Source Id'),
              DTColumnBuilder.newColumn('sourceName').withTitle('Source Name'),
              DTColumnBuilder.newColumn('nasracSourceTypeSourceType').withTitle('Source Type')
        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
        	vm.dtColumns[0].visible = false;
        }


        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }

    }
})();
